import { CaretRight, FunnelSimple } from "@phosphor-icons/react";
import { clsx } from "clsx";

import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";

import type { JSX } from "react";

export default function MobileFilters({
  filtersComponent,
  resetFilters,
}: {
  filtersComponent: JSX.Element;
  resetFilters: () => void;
}) {
  return (
    <Drawer>
      <DrawerTrigger className="flex items-center gap-x-2 rounded-4xl border border-black-200 p-4">
        <Button variant="secondary-black" intent="labelIcon">
          <FunnelSimple />
        </Button>
        <span className="text-lg-bold">Filters</span>
        <Button variant="ghost-black" intent="labelIcon" className="ml-auto">
          <CaretRight />
        </Button>
      </DrawerTrigger>

      <DrawerContent>
        <div className="mb-4 flex items-center justify-between">
          <span className="text-xl-bold">Filters</span>
          <Button
            variant="ghost-danger"
            size="lg"
            className={clsx(!resetFilters && "invisible")}
            onClick={resetFilters}
          >
            Clear all
          </Button>
        </div>
        {filtersComponent}
      </DrawerContent>
    </Drawer>
  );
}
